import React, { lazy, Suspense } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  BrowserRouter,
} from 'react-router-dom'
import styles from './App.module.css'
import ScrollToTopRoute from './Components/ScrollTop/ScrollTop'
import Header from './Components/Header/HeaderLite'
import BlogEntry from './Components/BlogEntry/BlogEntry'
import Blog from './Components/Blog/Blog'
import countryData from './countryData'

import AppContext from './context'

const set1stDataLocalStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify([value]))
}

const isNull = (data) => data === null

const getDataFromLocalStorage = (key) => {
  const data = JSON.parse(window.localStorage.getItem(key))
  return isNull(data) ? [] : data
}

const set1stOrganicLocalStorage = (key) => {
  window.localStorage.setItem(key, JSON.stringify(['organico']))
}

const setDataLocalStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

const proccessDataLocalStorage = (name, data) => {
  if (isNull(data)) {
    const dataFromLocalStorage = getDataFromLocalStorage(name)
    if (dataFromLocalStorage.length > 0) {
      dataFromLocalStorage.push('organico')
      setDataLocalStorage(name, dataFromLocalStorage)
    } else {
      set1stOrganicLocalStorage(name)
    }
  } else {
    const dataFromLocalStorage = getDataFromLocalStorage(name)
    if (dataFromLocalStorage.length < 15) {
      dataFromLocalStorage.push(data)
      setDataLocalStorage(name, dataFromLocalStorage)
    } else {
      set1stDataLocalStorage(name, data)
    }
  }
}

const saveUtm_info = (
  source,
  campain,
  medium,
  creative,
  payment,
  appointment,
  content
) => {
  proccessDataLocalStorage('utm_source', source)
  proccessDataLocalStorage('utm_campaign', campain)
  proccessDataLocalStorage('utm_medium', medium)
  proccessDataLocalStorage('creative', creative)
  proccessDataLocalStorage('payment_source', payment)
  proccessDataLocalStorage('appointment_source', appointment)
  proccessDataLocalStorage('utm_content', content)
}

function App() {
  const getCountry = () => {
    const country = window.location.href
    // country = "https://mymoons.co";
    if (country.includes('mymoons.mx')) {
      document.documentElement.lang = 'es-mx'
      return 'mx'
    } if (country.includes('mymoons.co')) {
      document.documentElement.lang = 'es-co'
      return 'co'
    } return 'mx'
  }

  const country = getCountry()

  const url = new URL(window.location.href)
  const utm_source = url.searchParams.get('utm_source')
  const utm_campaign = url.searchParams.get('utm_campaign')
  const utm_medium = url.searchParams.get('utm_medium')
  const utm_content = url.searchParams.get('utm_content')
  const creative = url.searchParams.get('creative')
  const appointment = url.searchParams.get('appointment_source')
  const payment = url.searchParams.get('payment_source')
  saveUtm_info(
    utm_source,
    utm_campaign,
    utm_medium,
    creative,
    payment,
    appointment,
    utm_content
  )

  const Footer = lazy(() => import('./Components/Footer/Footer'))
  
  console.log('path', window.location)
  return (
    <AppContext.Provider value={{ country, countryData }}>
      <BrowserRouter>
        <Router>
          {country === 'mx' ? (
            <Switch>
              <ScrollToTopRoute
                exact
                path="/blog"
              >
                <div className={styles.mainContent}>
                  <Suspense fallback={<div />}>
                    <Header
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Blog />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Footer
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                </div>
              </ScrollToTopRoute>
              <ScrollToTopRoute
                exact
                path="/blog/:slug"
              >
                <div className={styles.mainContent}>
                  <Suspense fallback={<div />}>
                    <Header
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Route
                      exact
                      path="/blog/:slug"
                      component={BlogEntry}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Footer
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                </div>
              </ScrollToTopRoute>
            </Switch>
          ) : (
            <Switch>
              <ScrollToTopRoute
                exact
                path="/blog"
              >
                <div className={styles.mainContent}>
                  <Suspense fallback={<div />}>
                    <Header
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Route
                      exact
                      path="/blog"
                      component={Blog}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Footer
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                </div>
              </ScrollToTopRoute>
              <ScrollToTopRoute
                exact
                path="/blog/:slug"
              >
                <div className={styles.mainContent}>
                  <Suspense fallback={<div />}>
                    <Header
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Route
                      exact
                      path="/blog/:slug"
                      component={BlogEntry}
                    />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Footer
                      country={country}
                      countryData={countryData[country]}
                    />
                  </Suspense>
                </div>
              </ScrollToTopRoute>
            </Switch>
          )}
        </Router>
      </BrowserRouter>
    </AppContext.Provider>
  )
}

export default App
